import { connect } from 'react-redux';

import Navigation from '../../components/navigation';

import {
    toggleMobileNav,
    toggleSearch,
    toggleExpandNav,
    unAuthUser,
    unAuthDevUser
} from '../../actions';

import { getNavItems, getBadgeCount } from '../../reducers';

const mapStateToProps = state => ({
    userInfo: state.data.userInfo,
    items: getNavItems(state),
    navActive: state.ui.navActive,
    searchActive: state.ui.searchActive,
    expandNav: state.ui.expandNav,
    formSaved: state.events.formSaved,
    formTouched: state.forms.event.$form.touched,
    badgeCount: getBadgeCount(state)
});

const mapDispatchToProps = dispatch => ({
    toggleMobileNav: () => dispatch(toggleMobileNav()),
    toggleSearch: () => dispatch(toggleSearch()),
    toggleExpandNav: () => dispatch(toggleExpandNav()),
    unAuthUser: () => dispatch(unAuthUser()),
    unAuthDevUser: () => dispatch(unAuthDevUser())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Navigation);



// WEBPACK FOOTER //
// ./src/containers/navigation/index.js